export const getSourcesPeriodDisplayValue = (
    fundedValue: number, projectionValue: number, periodIndex: number, inCurrentPeriodIndex: number, isFutureTimeline: boolean,
) => {
    const inCurrentPeriod = periodIndex === inCurrentPeriodIndex;

    const isBeforeCurrentPeriod = !inCurrentPeriod
        && (periodIndex < Number(inCurrentPeriodIndex) || (inCurrentPeriodIndex === undefined && !isFutureTimeline));

    const isAfterCurrentPeriod = !inCurrentPeriod
        && (periodIndex > Number(inCurrentPeriodIndex) || (inCurrentPeriodIndex === undefined && isFutureTimeline));

    if (isBeforeCurrentPeriod) {
        return fundedValue;
    } if (inCurrentPeriod) {
        return fundedValue + projectionValue;
    } if (isAfterCurrentPeriod) {
        return projectionValue;
    }

    return 0;
};
